import { render, staticRenderFns } from "./header.vue?vue&type=template&id=5af8371f&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=5af8371f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af8371f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlatformSelection: require('/app/components/PlatformSelection.vue').default})
